/* Scripts du thème (sans dépendance) */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const theme = window.theme || {};
  const routes = theme.routes || { cart: '/cart', cartAdd: '/cart/add' };
  const t = Object.assign({ addToCart: 'Add to cart', soldOut: 'Sold out', unavailable: 'Unavailable', added: '__TITLE__', addError: 'Error' }, theme.strings || {});

  /* ---------- Format monétaire ---------- */
  function formatMoney(cents) {
    const fmt = theme.moneyFormat || '{{amount}} €';
    const value = Number(cents) / 100;
    const group = (n, dec, th, dp) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(dp);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_space_separator': return group(value, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        default: return group(value, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message, ok = true) {
    const el = $('[data-toast]');
    if (!el) return;
    $('[data-toast-text]', el).textContent = message; // textContent : pas d'injection HTML
    el.classList.toggle('is-error', !ok);
    el.hidden = false;
    el.style.animation = 'none'; void el.offsetWidth; el.style.animation = '';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 4000);
  }

  async function refreshCartCount() {
    try {
      const res = await fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
        el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      });
    } catch (e) { /* silencieux */ }
  }

  /* ---------- Ajout au panier AJAX ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const buttons = $$('[type=submit]', form).concat(form.id ? $$(`[form="${form.id}"]`) : []);
    buttons.forEach((b) => { b.classList.add('is-loading'); b.disabled = true; });
    try {
      if (theme.demo) {
        await new Promise((r) => setTimeout(r, 600));
        const count = $('[data-cart-count]');
        if (count) { count.textContent = String((parseInt(count.textContent, 10) || 0) + 1); count.hidden = false; count.classList.remove('bump'); void count.offsetWidth; count.classList.add('bump'); }
        toast(t.added.replace('__TITLE__', ''));
        return;
      }
      const res = await fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || t.addError);
      await refreshCartCount();
      toast(t.added.replace('__TITLE__', data.product_title));
    } catch (err) {
      toast(err.message, false);
    } finally {
      buttons.forEach((b) => { b.classList.remove('is-loading'); b.disabled = false; });
    }
  });

  /* ---------- Quantité ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    const min = parseInt(input.min || '0', 10);
    const next = (parseInt(input.value, 10) || 0) + (btn.hasAttribute('data-qty-plus') ? 1 : -1);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Soumission auto (tri collection, quantités panier) */
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-auto-submit]') && e.target.form) {
      clearTimeout(e.target._t);
      e.target._t = setTimeout(() => e.target.form.submit(), 450);
    }
  });

  /* ---------- Fiche produit ---------- */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const idInput = $('[data-variant-id]', root);
    const mainImg = $('[data-main-image]', root);
    const atc = $('[data-atc]', root);
    const atcLabel = $('[data-atc-label]', root);
    const stickyBtn = $('[data-sticky-btn]');
    const stickyPrice = $('[data-sticky-price]');

    // Galerie
    $$('[data-thumb]', root).forEach((t) => t.addEventListener('click', () => setImage(t.dataset.src, t)));
    function setImage(src, thumb) {
      if (!mainImg || !src) return;
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.removeAttribute('srcset');
        mainImg.src = src;
        mainImg.style.opacity = '1';
      }, 150);
      $$('[data-thumb]', root).forEach((x) => x.classList.toggle('is-active', x === thumb));
    }

    // Variantes
    root.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option]')) return;
      const groups = $$('[data-option-group]', root);
      const selected = groups.map((g) => { const c = $('input:checked', g); return c ? c.value : null; });
      groups.forEach((g, i) => { const l = $('[data-option-label]', g); if (l) l.textContent = selected[i]; });
      const variant = product.variants.find((v) => v.options.every((o, i) => o === selected[i]));
      update(variant);
    });

    function update(v) {
      const priceEl = $('[data-price]', root);
      const compareEl = $('[data-compare]', root);
      const save = $('[data-save]', root);
      const badge = $('[data-save-badge]', root);
      if (!v) {
        atc.disabled = true; atcLabel.textContent = t.unavailable;
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      compareEl.hidden = !onSale; save.hidden = !onSale; badge.hidden = !onSale;
      if (onSale) {
        compareEl.textContent = formatMoney(v.compare_at_price);
        $('[data-save-amount]', save).textContent = formatMoney(v.compare_at_price - v.price);
        badge.textContent = `-${Math.floor(((v.compare_at_price - v.price) * 100) / v.compare_at_price)}%`;
      }
      atc.disabled = !v.available;
      if (stickyBtn) stickyBtn.disabled = !v.available;
      atcLabel.textContent = v.available ? t.addToCart : t.soldOut;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }

    // Barre d'achat collante
    const sticky = $('[data-sticky-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(atc);
    }
  });

  /* ---------- En-tête & menu mobile ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  $$('[data-close-drawer]').forEach((b) => b.addEventListener('click', () => b.closest('details').removeAttribute('open')));

  /* ---------- Apparition au scroll ---------- */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }
})();
